import { Deserializable } from './deserializable';
import { BaseModel } from './baseModel';
import { DateHelper } from '../util/dateHelper';


export class NewUserRequestPermissionType extends BaseModel implements Deserializable {

  name: string;

  fileNames: string[];

  ownerUid: string;

  deserialize(input: any) {

    super.deserialize(input);
    Object.assign(this, input);

    return this;
  }

}
